/**
 * A RecordDefInstance Factory.
 * 
 * Implements empty(), get(), import()
 * MAZ - 2020-05-09
 */
import { cloned, copyAttrsOnly, CustomException } from '@/helpers'
import { buildMetadata } from './metadata';


const _EMPTY = {
  id: -1,
  account_id: -1,
  master_id: -1,
  state: "",
  title: "",
  descr: "",
  version: "" , 
  category: "Todos",
  form: {},
  struct: {},
  views: {},
  
  // Metadata: normalized Dictionary for Section and Fields
  meta: {}, 
}


export const RecordDef = {

  key: 'record-def', // used in Schema and for Obj Idn

  empty() {
    /**
     * Returns an EMPTY instance.
     * @returns: initialized RecordDefInstance
     */
    return cloned(_EMPTY)
  },

  import (obj) {
    /**
     * Import a JSON obj coming from the API
     */
    let oi = this.empty();
    oi = copyAttrsOnly(oi, obj);

    // sometimes when geting a collection, the 'data' field
    // may not be present, so we catch it ...
    oi.form = cloned(obj.data ? obj.data.form : {})
    oi.struct = cloned(obj.data ? obj.data.struct : {})
    oi.views = cloned(obj.data ? obj.data.views : {})

    // build the metadata info
    oi.meta = buildMetadata(obj.data ? obj.data.form : null)

    return oi;
  },

  get (id) {
    let r = localStorage.getItem(this.key+'-'+id);
    return (r ? JSON.parse(r) : null)     
  },

  save (obj) {
    localStorage.setItem(this.key+'-'+obj.id, JSON.stringify(obj))
    if (obj.state === "A" || obj.state === "E") {
      localStorage.setItem('master-def-'+obj.master_id, JSON.stringify(obj));
    }
  }
}
